// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * Check if imageType is video or not
 */
export const isVideoType = (imageType?: string) => {
    return imageType?.toLowerCase() === "video";
};

/**
 * extract thumbnail from YouTube or any other api
 * if the video api isn't support, we return primary image for product/item as defaultImage
 */
export const getThumbnailUrl = (videoUrl: string, defaultImage?: string): string => {
    // Regular expression to match YouTube video URLs
    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    // Check if the URL matches the YouTube regex
    const youtubeUrl = videoUrl.match(youtubeRegex);

    if (youtubeUrl) {
        const videoId = youtubeUrl[5];
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }

    return defaultImage || "";
};
